import CitySEOHead from "@/components/feature/CitySEOHead";
import KingsportHeroSection from "./components/HeroSection";
import KingsportStickyNav from "./components/StickyNav";
import KingsportProcessingTimeSection from "./components/ProcessingTimeSection";
import KingsportServicesSection from "./components/ServicesSection";
import KingsportLocalAreaSection from "./components/LocalAreaSection";
import KingsportTravelTimingSection from "./components/TravelTimingSection";
import KingsportDestinationsSection from "./components/DestinationsSection";
import KingsportTestimonialsSection from "./components/TestimonialsSection";
import KingsportAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import KingsportComparisonSection from "./components/ComparisonSection";
import KingsportMistakesSection from "./components/MistakesSection";
import KingsportHowItWorksSection from "./components/HowItWorksSection";
import KingsportFAQSection, { faqs } from "./components/FAQSection";
import KingsportHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import KingsportFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const kingsportServices = [
  { name: "Emergency Passport Kingsport TN", description: "Urgent passport processing for Kingsport and Sullivan County travelers with immediate international departure needs, as fast as 24 hours." },
  { name: "Expedited Passport Renewal Kingsport TN", description: "Fast passport renewal for Eastman Chemical professionals, BAE Systems contractors, and Sullivan County residents — 2-9 business days." },
  { name: "New Passport Kingsport TN", description: "First-time passport application assistance for Kingsport-area residents with acceptance facility scheduling support." },
  { name: "Child Passport Kingsport TN", description: "Minor passport services for Sullivan County families, with parental consent guidance and step-by-step acceptance clerk support." },
  { name: "Lost Stolen Passport Replacement Kingsport TN", description: "Fast replacement of lost or stolen passports for Kingsport and Sullivan County residents." },
  { name: "Corporate Passport Services Kingsport TN", description: "Expedited passport processing for Eastman Chemical executives and BAE Systems defense contractors with compressed international travel timelines." },
];

export default function KingsportPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Kingsport"
        state="Tennessee"
        stateAbbr="TN"
        route="/cities/kingsport"
        title="Emergency Passport Kingsport, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Kingsport, TN and Sullivan County — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Eastman Chemical executives, BAE Systems contractors, and Tri-Cities families. No Knoxville agency drive required."
        geoPlacename="Kingsport, Tennessee"
        geoPosition="36.5484;-82.5618"
        faqs={faqs}
        servicesSchema={kingsportServices}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <KingsportHeroSection />
      <KingsportStickyNav />
      <KingsportProcessingTimeSection />
      <KingsportServicesSection />
      <KingsportLocalAreaSection />
      <KingsportTravelTimingSection />
      <KingsportDestinationsSection />
      <KingsportTestimonialsSection />
      <KingsportAcceptanceFacilitiesSection />
      <KingsportComparisonSection />
      <KingsportMistakesSection />
      <KingsportHowItWorksSection />
      <KingsportFAQSection />
      <KingsportHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/kingsport" state="TN" />
      <KingsportFinalCTA />
    </div>
  );
}